import { Space } from "antd";
import FAQSection from "../components/FAQSection";
import AboutSection from "../components/homepage/AboutSection";
import AudienceSection from "../components/homepage/AudienceSection";
import CollectionsSection from "../components/homepage/CollectionsSection";
import ExperienceSection from "../components/homepage/ExperienceSection";
import Features from "../components/homepage/Features";
import FinalCTA from "../components/homepage/FinalCTA";
import Hero from "../components/homepage/Hero";
import HowItWorks from "../components/homepage/HowItWorks";
import PlannerSection from "../components/homepage/PlannerSection";
import PricingPreview from "../components/homepage/PricingPreview";
import SectionSeparator from "../components/homepage/SectionSeparator";
import WhyChooseSection from "../components/homepage/WhyChooseSection";
import ZonesSection from "../components/homepage/ZonesSection";
import PageLayout from "./PageLayout";

const Homepage = () => {
	return (
		<PageLayout fullWidthContent={<Hero />}>
			<Space
				orientation="vertical"
				size={160}
				style={{ width: "100%", padding: "60px 14px 14px" }}
			>
				<div>
					<SectionSeparator title="What is BodhiStreams?" />
					<AboutSection />
				</div>
				<div>
					<SectionSeparator title="Collections" />
					<CollectionsSection />
				</div>
				<div>
					<SectionSeparator title="Built for Hospitality & Wellness" />
					<AudienceSection />
				</div>
				<div>
					<SectionSeparator title="Why BodhiStreams" />
					<div
						style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 24px" }}
					>
						<Features />
					</div>
				</div>
				<div>
					<SectionSeparator title="Multiple Zones, Multiple Experiences" />
					<ZonesSection />
				</div>
				<div>
					<SectionSeparator title="BodhiStreams Planner" />
					<PlannerSection />
				</div>
				<div>
					<SectionSeparator title="How It Works" />
					<HowItWorks />
				</div>
				<div>
					<SectionSeparator title="Experience BodhiStreams" />
					<ExperienceSection />
				</div>
				<div>
					<WhyChooseSection />
				</div>
				<div>
					<SectionSeparator title="Pricing Plans" />
					<PricingPreview />
				</div>
				<div>
					<FAQSection />
				</div>
				<div style={{ marginBottom: 120 }}>
					<SectionSeparator title="Stream Your Space" />
					<FinalCTA />
				</div>
			</Space>
		</PageLayout>
	);
};

export default Homepage;
